module.exports = __webpack_public_path__ + "static/media/chirp.2d8cd8eb.mp3";